module.exports = __webpack_public_path__ + "img/fr.74ef4e8a.svg";